module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_26_LICZEBNIKI_3_A.1c1daa27.mp3";